
import React, { useCallback, useState } from "react";
import axios from "axios";
import './style.css'

function toggle(value) {
  return !value;
}

function ModalBasic({ setModalOpen }) {
  const closeModal = () => {
    setModalOpen(false);
  };
  const [newEmail, setNewEmail] = useState('')
  const [newName, setNewName] = useState('')
  const [newCompany, setNewCompany] = useState('')
  const [checked, setChecked] = useState(false);

  const onChangeNewEmail = ((e) => {
    e.preventDefault();
    setNewEmail(e.target.value);
  })
  const onChangeNewName = ((e) => {
    e.preventDefault();
    setNewName(e.target.value);
  })
  const onChangeNewCompany = ((e) => {
    e.preventDefault();
    setNewCompany(e.target.value);
  })
  const onChangeChecked = ((e) => {
    e.preventDefault();
    setChecked(toggle);
  })

  const onSubscribe = useCallback((e) => {
    e.preventDefault();
    axios
      .post('https://api.testworks.co.kr/subscribes', {
        email: newEmail,
        name: newName,
        company_name: newCompany,
        is_subscribe: checked,
      })
      .then(() => {
        alert('뉴스레터 구독 신청이 완료되었습니다.')
        setModalOpen(false);
      })
      .catch((error) => {
        console.dir(error);
      })
  }, [newEmail, newName, newCompany, checked, setModalOpen]);

  return (
    <form className="container" onSubmit={onSubscribe}>
      <div id="lp_layout">
        <div className="lp_wrap lp_newsletter on">
          <div className="head">
            <h2>에이아이웍스 뉴스레터 구독하기</h2>
            <p>AI&DATA 최신 인사이트를 받아보세요!</p>
          </div>
          <div className="body">
            <div className="inputBox">
              <dl>
                <dt>기업명(필수)</dt>
                <dd><input type="text" name="company_name" value={newCompany} onChange={onChangeNewCompany} /></dd>
              </dl>
              <dl>
                <dt>이름(필수)</dt>
                <dd><input type="text" name="name" value={newName} onChange={onChangeNewName} /></dd>
              </dl>
              <dl>
                <dt>이메일(필수)</dt>
                <dd><input type="text" name="email" value={newEmail} onChange={onChangeNewEmail} /></dd>
              </dl>
            </div>
            <div className="agree_wrap">
              <span className="agree_box">
                <input id="policy" type="checkbox" name="Is_subscribe" value={checked} onChange={onChangeChecked} />
                <label for="policy" className="lanPack_lp_agree_txt1">위 개인정보 항목의 수집ㆍ이용에 동의합니다.(필수)</label>
              </span>
              <ul>
                <li>수집목적: 고객상담, 불만처리 등 민원사무 처리, 뉴스레터 등 광고성 정보제공 등 마케팅 및 프로모션</li>
                <li>보유기간: 동의일로부터 1년까지</li>
                <li>그 밖에 사항에 관하여 <a href="https://www.aiworkx.ai/terms_and_conditions.html" target="_blank" rel="noreferrer">개인정보 이용정책</a>을 참조하십시오.</li>
                <li>귀하는 개인정보 수집∙이용에 대한 동의를 거부할 수 있습니다. 그러나 동의를 거부할 경우, 본 서비스 이용에 제한이 있을 수 있습니다.</li>
              </ul>
            </div>
          </div>
          <div className="foot">
            <button>구독하기</button>
          </div>
          <button className="lp_close" onClick={closeModal}>닫기</button>
        </div>
      </div>

    </form>
  );
}
export default ModalBasic;

